import { REFEREES_REQUESTED } from '../constants/actionTypes';

export const loadReferees = ( context, token, gameId ) => {

    return {
        type:    REFEREES_REQUESTED,
        payload: { context, token, gameId }
    };

};